export const query = `query getProductBySlug($externalId: String!, $slug: String!, $withSubscriptionInfo: Boolean!, $withPricePerUnit: Boolean!, $withCountryCodes: Boolean!) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    product(slug: $slug, onlyVisible: true) {
      id
      description
      isVisible
      sku
      ribbon
      price
      comparePrice
      formattedPrice
      formattedComparePrice
      pricePerUnit @include(if: $withPricePerUnit)
      formattedPricePerUnit @include(if: $withPricePerUnit)
      pricePerUnitData @include(if: $withPricePerUnit) {
        baseQuantity
        baseMeasurementUnit
      }
      seoTitle
      seoDescription
      createVersion
      digitalProductFileItems {
        fileId
        fileType
        fileName
      }
      productItems {
        price
        comparePrice
        formattedPrice
        formattedComparePrice
        pricePerUnit @include(if: $withPricePerUnit)
        formattedPricePerUnit @include(if: $withPricePerUnit)
        optionsSelections
        isVisible
        inventory {
          status
          quantity
        }
        sku
        weight
        surcharge
        subscriptionPlans @include(if: $withSubscriptionInfo) {
          list {
            id
            price
            formattedPrice
            pricePerUnit @include(if: $withPricePerUnit)
            formattedPricePerUnit @include(if: $withPricePerUnit)
          }
        }
      }
      name
      isTrackingInventory
      inventory {
        status
        quantity
      }
      isVisible
      isManageProductItems
      isInStock
      media {
        id
        url
        fullUrl
        altText
        thumbnailFullUrl: fullUrl(width: 50, height: 50)
        mediaType
        videoType
        videoFiles {
          url
          width
          height
          format
          quality
        }
        width
        height
        index
        title
      }
      customTextFields {
        title
        isMandatory
        inputLimit
      }
      nextOptionsSelectionId
      options {
        title
        optionType
        selections {
          id
          value
          description
          linkedMediaItems {
            altText
            url
            fullUrl
            thumbnailFullUrl: fullUrl(width: 50, height: 50)
            mediaType
            width
            height
            index
            title
            videoFiles {
              url
              width
              height
              format
              quality
            }
          }
        }
      }
      productType
      urlPart
      additionalInfo {
        id
        title
        description
        index
      }
      subscriptionPlans @include(if: $withSubscriptionInfo) {
        list(onlyVisible: true) {
          id
          name
          tagline
          frequency
          duration
          price
          formattedPrice
          pricePerUnit @include(if: $withPricePerUnit)
          formattedPricePerUnit @include(if: $withPricePerUnit)
        }
        oneTimePurchase {
          index
        }
      }
      discount {
        mode
        value
      }
      currency
      weight
      seoJson
    }
  }
  localeData(language: "en") @include(if: $withCountryCodes) {
    countries {
      key
      shortKey
    }
  }
}`;
